/* tslint:disable */
/* eslint-disable */
/**
 * MVC Games
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateSeasonRequest,
  ErrorModel,
  ListSeasonsOutputBody,
  ReplaceSeasonRequest,
  Season,
} from '../models/index';
import {
    CreateSeasonRequestFromJSON,
    CreateSeasonRequestToJSON,
    ErrorModelFromJSON,
    ErrorModelToJSON,
    ListSeasonsOutputBodyFromJSON,
    ListSeasonsOutputBodyToJSON,
    ReplaceSeasonRequestFromJSON,
    ReplaceSeasonRequestToJSON,
    SeasonFromJSON,
    SeasonToJSON,
} from '../models/index';

export interface CreateSeasonOperationRequest {
    createSeasonRequest: Omit<CreateSeasonRequest, '$schema'>;
}

export interface GetSeasonRequest {
    id: number;
}

export interface ListSeasonsRequest {
    f?: string;
    p?: string;
    s?: string;
}

export interface ReplaceSeasonOperationRequest {
    id: number;
    replaceSeasonRequest: Omit<ReplaceSeasonRequest, '$schema'>;
}

/**
 * 
 */
export class SeasonsApi extends runtime.BaseAPI {

    /**
     * Creates request options for createSeason without sending the request
     */
    async createSeasonRequestOpts(requestParameters: CreateSeasonOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['createSeasonRequest'] == null) {
            throw new runtime.RequiredError(
                'createSeasonRequest',
                'Required parameter "createSeasonRequest" was null or undefined when calling createSeason().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/seasons`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateSeasonRequestToJSON(requestParameters['createSeasonRequest']),
        };
    }

    /**
     * Create season
     * Create Season
     */
    async createSeasonRaw(requestParameters: CreateSeasonOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Season>> {
        const requestOptions = await this.createSeasonRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SeasonFromJSON(jsonValue));
    }

    /**
     * Create season
     * Create Season
     */
    async createSeason(requestParameters: CreateSeasonOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Season> {
        const response = await this.createSeasonRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getSeason without sending the request
     */
    async getSeasonRequestOpts(requestParameters: GetSeasonRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getSeason().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/seasons/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get season
     * Get Season
     */
    async getSeasonRaw(requestParameters: GetSeasonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Season>> {
        const requestOptions = await this.getSeasonRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SeasonFromJSON(jsonValue));
    }

    /**
     * Get season
     * Get Season
     */
    async getSeason(requestParameters: GetSeasonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Season> {
        const response = await this.getSeasonRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listSeasons without sending the request
     */
    async listSeasonsRequestOpts(requestParameters: ListSeasonsRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['f'] != null) {
            queryParameters['f'] = requestParameters['f'];
        }

        if (requestParameters['p'] != null) {
            queryParameters['p'] = requestParameters['p'];
        }

        if (requestParameters['s'] != null) {
            queryParameters['s'] = requestParameters['s'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/seasons`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List seasons
     * List Seasons
     */
    async listSeasonsRaw(requestParameters: ListSeasonsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListSeasonsOutputBody>> {
        const requestOptions = await this.listSeasonsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListSeasonsOutputBodyFromJSON(jsonValue));
    }

    /**
     * List seasons
     * List Seasons
     */
    async listSeasons(requestParameters: ListSeasonsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListSeasonsOutputBody> {
        const response = await this.listSeasonsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for replaceSeason without sending the request
     */
    async replaceSeasonRequestOpts(requestParameters: ReplaceSeasonOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling replaceSeason().'
            );
        }

        if (requestParameters['replaceSeasonRequest'] == null) {
            throw new runtime.RequiredError(
                'replaceSeasonRequest',
                'Required parameter "replaceSeasonRequest" was null or undefined when calling replaceSeason().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/seasons/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ReplaceSeasonRequestToJSON(requestParameters['replaceSeasonRequest']),
        };
    }

    /**
     * Replace season
     * Replace Season
     */
    async replaceSeasonRaw(requestParameters: ReplaceSeasonOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Season>> {
        const requestOptions = await this.replaceSeasonRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SeasonFromJSON(jsonValue));
    }

    /**
     * Replace season
     * Replace Season
     */
    async replaceSeason(requestParameters: ReplaceSeasonOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Season> {
        const response = await this.replaceSeasonRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
